/**
 *
 * ResultsDrTableHead
 *
 */

import React, { memo, FunctionComponent } from 'react';
import SortIndicatorComponent from '../../../../components/SortIndicator/SortIndicator.component';
import { Sort } from '../../../../domain';

interface IProps {
  changeSort: (field: string) => void;
  sort?: Sort;
  disabledFields: string[];
}

const ResultsCBTableHead: FunctionComponent<IProps> = ({
  sort,
  disabledFields,
  changeSort,
}) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };
  return (
    <thead>
      <tr>
        <th scope="col">
          <SortIndicatorComponent
            field="eaEventClassAndSort"
            name="Class"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionName"
            name="Section"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col" colSpan={3}>
          <SortIndicatorComponent
            field="bridleNumber"
            name="Rider/BN"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="dressageTime"
            name="DR Time"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="showJumpingTime"
            name="SJ Time"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="dressageScore"
            name="Score"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sjPenalties"
            name="SJ Penalties"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="dressageCollective"
            name="Colls"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="eaDressagePercentageCustom"
            name="%"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field={
              isEnabled('totalCBScore') ? 'totalCBScore' : 'totalCBScoreBE'
            }
            name="Total Score"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionPlace"
            name="SP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="overallPlace"
            name="OP"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="riderClassStatusName"
            name="Status"
            sort={sort}
            changeSort={changeSort}
            disabledFields={disabledFields}
          />
        </th>
      </tr>
    </thead>
  );
};

export default memo(ResultsCBTableHead);
